import MaterialTable, { MaterialTableProps, Options } from '@material-table/core'
import { makeStyles } from '@material-ui/core'
import { CSSProperties } from 'react'

const useStyles = ({ hideBorderBottom = false }) => {
	// Super hacky, but the library has no way to hide the bottom border on the pagination component
	const hiddenBorderStyle = hideBorderBottom
		? {
				'& *.MuiTablePagination-root': {
					borderBottom: 'none'
				}
		  }
		: {}
	return makeStyles(() => ({
		root: {
			...hiddenBorderStyle
		}
	}))
}

/**
 *
 * @param {MaterialTableProps & {headerStyle?: CSSProperties, rowStyle?: CSSProperties, overrideOptions?: Options, hideBorderBottom?: boolean}} props
 * @returns
 */
const StyledTable = (props) => {
	const classes = useStyles({ hideBorderBottom: props?.hideBorderBottom })()
	const passedStyles = props.style || {}
	const passedHeaderStyles = props.headerStyle || {}
	const passedRowStyles = props.rowStyle || {}
	const passedOverrideOptions = props.overrideOptions || {}
	return (
		<div className={classes.root}>
			<MaterialTable
				style={{ ...passedStyles, flex: 1 }}
				options={{
					sorting: true,
					toolbar: false,
					headerStyle: {
						color: '#1A1A35',
						textTransform: 'uppercase',
						fontWeight: 800,
						fontSize: '12px',
						lineHeight: '16px',
						// padding: '11px 24px',
						borderTop: '1px solid #D0CFD2',
						backgroundColor: '#F9F9F9',
						...passedHeaderStyles
					},
					rowStyle: {
						backgroundColor: 'white',
						verticalAlign: 'middle',
						width: '100%',
						...passedRowStyles
					},
					pageSize: 10,
					pageSizeOptions: [10, 20, 50],
					toolbarButtonAlignment: 'left',
					searchFieldAlignment: 'left',
					...passedOverrideOptions
				}}
				{...props}
			/>
		</div>
	)
}

export default StyledTable
